import { purchaseMethodLabel } from "./allPolicyHelpers";

export const coverTypeColor = (type) =>
  String(type).toLowerCase() === "international" ? "violet" : "blue";

export const purchaseColor = (method) => {
  const key = purchaseMethodLabel(method);
  if (key === "BULK") return "violet";
  if (key === "online") return "blue";
  return "gray";
};
